import type { IUserRepository, PaginationParams } from "@src/domain/users/repository/user.repository.interface";
import type { PaginatedUsersDTO } from "../dto/user.dto";
import { UserDtoMapper } from "../mappers/user-dto.mapper";

/**
 * Use Case: List All Users
 * Fetches all users with pagination (Admin only)
 */
export class ListAllUsersUseCase {
    constructor(private readonly userRepository: IUserRepository) { }

    /**
     * Execute the use case
     * @param params - Pagination parameters
     * @returns Promise<PaginatedUsersDTO> - Paginated list of users
     */
    async execute(params?: PaginationParams): Promise<PaginatedUsersDTO> {
        const result = await this.userRepository.listAll(params);

        return {
            users: UserDtoMapper.toListItemDTOs(result.items),
            total: result.total,
            page: result.page,
            page_size: result.page_size,
            total_pages: result.total_pages,
            hasMore: result.hasMore,
        };
    }
}
